import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'y42-smart-btn',
  templateUrl: './smart-btn.component.html',
  styleUrls: ['./smart-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmartBtnComponent {
  @Input() color: ThemePalette = 'primary';
  @Input() type = 'submit';
  @Input() class = '';
  @Input() lightOrDark: 'light' | 'dark' = 'light';

  @Input()
  pending?: boolean | null;

  @Input()
  disabled?: boolean | null;

  @HostBinding('style.pointer-events')
  get pointerEvents() {
    return this.disabled || this.pending ? 'none' : undefined;
  }
}
